import {Link, matchRoutes, LinkProps, useLocation} from "react-router-dom";
import React, {useContext, MouseEvent, forwardRef} from "react";
import {RouteContext} from "../../routes/RouteContext";
import {
    modalRoutes,
    authModalRoutes,
    authPageRoutes,
    matchLocalizedRoutes,
    translateRoute, inGameRoutes
} from "../../routes/AppRoutes";
import {useTranslation} from "react-i18next";

export const CustomLink = forwardRef(
    (props: LinkProps, ref) => {
    const routeState = useContext(RouteContext);
    const {t, i18n} = useTranslation();
    const {onClick,to,...restProps} = props;
    
    
    const checkDestinationRoute = (e: MouseEvent<HTMLAnchorElement>) => {
        const isAuthenticated = routeState.authenticated;
        onClick?.(e);
        // If location matches a modal location => set background location
        // OR if unauthenticated user tries to access authenticated route => set background location and navigate
        const searchParams = new URLSearchParams(props.to.toString().split('?')[1]);
        if ((matchLocalizedRoutes(modalRoutes, props.to,t) != null || (matchLocalizedRoutes(authModalRoutes, props.to,t) != null)) ||
            (matchLocalizedRoutes([...authPageRoutes, ...authModalRoutes], props.to,t) != null && !isAuthenticated) ||
            (matchLocalizedRoutes(inGameRoutes, props.to, t) != null && searchParams.get('mode') === 'cash' && !isAuthenticated)) {
            routeState.setRouteState({
                ...routeState,
                backgroundLocation: routeState.previousLocation
            });
        }
    };

    return (
        <Link {...restProps} ref={ref as any} to={translateRoute(to as string,i18n.language,t)} onClick={(e) => checkDestinationRoute(e)} />
    )
});
